import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { springVariants, rightVariants, leftVariants, springViewport } from '../utils/framerVariants'

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;
gsap.registerPlugin(ScrollTrigger);

const ParallaxTeaser = ({ data }) => {
  const isQuote = data.LayoutParallaxTeaser && data.LayoutParallaxTeaser.startsWith("Quote");
  const scrollTriggerRef = useRef(null); // Create a ref to store the ScrollTrigger instance

  useIsomorphicLayoutEffect(() => {
    // This will run on the client-side when the component mounts or updates

    gsap.registerPlugin(ScrollTrigger);

    gsap.to(`.slowHero__${data.id}`, {
      scrollTrigger: {
        trigger: `#slowHero__${data.id}`,
        scrub: true,
        pin: true,
        start: "center center",
        end: "bottom -10%",
        toggleClass: "active",
        ease: "cubic-bezier(0.5, .5, 0, 1)",
      },
    });

    gsap.to(`.slowHeroImage__${data.id}`, {
      scrollTrigger: {
        trigger: `#slowHero__${data.id}`,
        scrub: true,
        start: "top bottom",
        end: "bottom -10%",
        ease: "cubic-bezier(0.5, .5, 0, 1)",
      },
      yPercent: -5,
    });

    // Store the ScrollTrigger instance in the ref
    scrollTriggerRef.current = ScrollTrigger;

  }, [data.id]);

  // useLayoutEffect runs synchronously before painting, which is better for SSR
  useLayoutEffect(() => {
    // This will run only on the server-side (SSR)

    if (scrollTriggerRef.current) {
      // If ScrollTrigger has been initialized
      scrollTriggerRef.current.refresh(true); // Refresh ScrollTrigger to apply new changes
    }
  }, [data.id]);

  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de/');
  const quoteText = isGerman ? `„${data.Text}“` : `“${data.Text}”`;


  return (
    <>
      {isQuote ? (
        <article className="mb-16 md:mb-24 lg:mb-32 xl:mb-48 relative overflow-hidden w-screen">
          <div className={`mx-auto flex w-screen h-screen overflow-hidden slowHero__${data.id}`} id={`slowHero__${data.id}`}>
            <div className="hero__inner">
              <div className={`absolute top-0 left-0 w-full slowHeroImage__${data.id}`}>
                {data.ParallaxMedia &&
                  <GatsbyImage
                    className="w-screen h-[115vh] object-cover"
                    image={getImage(data.ParallaxMedia.file)}
                    alt={data.ParallaxMedia.alternativeText}
                  />
                }
              </div>
              {data.Text &&
                <div className="slowHeroContent h-screen w-full flex items-end">
                  <div className="hero__headline bg-yellow max-w-xl slowHeroForm">
                    <div className="pl-8 pb-8 pt-32 pr-40">

                        <h2 className="text-headline-md tracking-headline-md leading-headline-md font-bold">
                          {quoteText}
                        </h2>

                      {data.AuthorParallaxTeaser &&
                        <p className="text-text tracking-text leading-text">
                          <b>{data.AuthorParallaxTeaser}</b><br />
                          {data.AuthorDescriptionParallaxTeaser}
                        </p>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </article>
      ) : (
        <article className="mb-16 md:mb-24 lg:mb-32 xl:mb-48 relative overflow-hidden w-screen">
          <div className={`mx-auto flex w-screen h-screen overflow-hidden slowHero__${data.id}`} id={`slowHero__${data.id}`}>
            <div className="hero__inner">
              <div className={`absolute top-0 left-0 w-full slowHeroImage__${data.id}`}>
                {data.ParallaxMedia &&
                  <GatsbyImage
                    className="w-screen h-[115vh] object-cover"
                    image={getImage(data.ParallaxMedia.file)}
                    alt={data.ParallaxMedia.alternativeText}
                  />
                }
              </div>
              <div className="slowHeroContent h-screen w-full flex items-end">
                <div className="hero__headline bg-yellow max-w-xl slowHeroForm">
                  <div className="pl-8 pb-8 pt-32 pr-40">
                    {data.Text &&
                      <h2 className="text-headline-md tracking-headline-md leading-headline-md font-bold">
                        {data.Text}
                      </h2>
                    }
                    {data.AuthorParallaxTeaser &&
                      <p className="text-text tracking-text leading-text">
                        <b>{data.AuthorParallaxTeaser}</b><br />
                        {data.AuthorDescriptionParallaxTeaser}
                      </p>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      )}
    </>
  )
}

export default ParallaxTeaser
